import { useEffect, useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useStudentsUIContext } from "../StudentsUIContext";
import { AttendanceStatusOptions, CustomSelect, FilterOptions } from "../../../../../../../_helpers/Helpers";

const prepareFilter = (queryParams, values) => {
  let { date, sectionId, studentName, studentNumber, attendanceStatus } = values;
  studentNumber = studentNumber === "" ? null : studentNumber;
  const newQueryParams = { ...queryParams };
  const filter = { date, sectionId, studentName, studentNumber, attendanceStatus };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function StudentsFilter() {
  // Students UI Context
  const studentsUIContext = useStudentsUIContext();
  const studentsUIProps = useMemo(() => {
    return {
      date: studentsUIContext.date,
      sectionId: studentsUIContext.sectionId,
      queryParams: studentsUIContext.queryParams,
      setQueryParams: studentsUIContext.setQueryParams
    };
  }, [studentsUIContext]);

  useEffect(() => {
    applyFilter({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentsUIProps.date, studentsUIProps.sectionId]);

  const applyFilter = (values) => {
    values.date = studentsUIProps.date;
    values.sectionId = studentsUIProps.sectionId;
    const newQueryParams = prepareFilter(studentsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, studentsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      studentsUIProps.setQueryParams(newQueryParams);
    }
  };

  const attendanceStatusOptions = FilterOptions.concat(AttendanceStatusOptions.slice(1));

  return (
    <Formik
      initialValues={{
        studentName: "",
        studentNumber: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="number"
                className="form-control"
                name="studentNumber"
                min={1}
                placeholder="Öğrenci Numarası"
                onBlur={handleBlur}
                value={values.studentNumber}
                onChange={(e) => {
                  setFieldValue("studentNumber", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Öğrenci Numarası</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="studentName"
                placeholder="Adı Soyadı"
                onBlur={handleBlur}
                value={values.studentName}
                onChange={(e) => {
                  setFieldValue("studentName", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={attendanceStatusOptions}
                value={values.attendanceStatus}
                placeholder="Yoklama Durumu"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("attendanceStatus", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Yoklama Durumu</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}